import { useCallback } from 'react';
import { useSystemSettings } from '../settings/SystemSettingsProvider';
import { useSummary } from '../summary/useSummaryService';
import { useTasks } from '../tasks/useTasks';
import { useMyLocation } from '../useLocations';
import { applyShiftsToSummary } from './rosterSummaryHelper';
import { useDaysInMonth } from '../settings/useDates';

export const useBuildRosterSummary = (date: Date) => {
  const days = useDaysInMonth(date);
  const { allEmployeesSummary: baseSummary } = useSummary(days[0], days[days.length - 1]);

  const tasks = useTasks();
  const includeBreaks = useSystemSettings(s => s.settings.includeBreaksInTotals);

  const locationId = useMyLocation().id;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(applyShiftsToSummary(baseSummary, date, tasks, locationId, includeBreaks), [
    baseSummary,
    date,
    tasks,
    includeBreaks,
    locationId
  ]);
};
